import type { RouteRecordRaw } from "vue-router";

export const pupilFeedbackRoutes: RouteRecordRaw[] = [
  {
    path: "/pupil_feedback/info",
    name: "pupil_feedback-info",
    component: () => import("./info/PupilFeedbackInfoPage.vue"),
    meta: {
      namespace: "pupil_feedback",
      title: "tools_meta.pupil_feedback_prefix",
    },
  },
  {
    path: "/pupil_feedback/assignments",
    name: "pupil_feedback-index",
    component: () => import("./assignments/AssignmentListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "pupil_feedback",
      title: "tools_meta.pupil_feedback_prefix",
    },
  },
  {
    path: "/pupil_feedback/assignments/:id",
    name: "pupil_feedback-show",
    component: () => import("./assignments/AssignmentLayout.vue"),
    meta: {
      requiresAuth: true,
      title: "tools_meta.pupil_feedback_prefix",
    },
    children: [
      {
        path: "settings",
        name: "pupil_feedback-settings",
        component: () => import("./assignments/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "pupil_feedback",
          title: "tools_meta.pupil_feedback_prefix",
        },
      },
      {
        path: "share",
        name: "pupil_feedback-share",
        component: () => import("./assignments/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "pupil_feedback",
          title: "tools_meta.pupil_feedback_prefix",
        },
      },
    ],
  },
  // Parent layout wraps children in <WithVisitor> via <router-view />
  {
    path: "/pupil_feedback/assignments/:id/public_responses",
    component: () => import("./assignments/[id].public_responses.vue"),
    children: [
      {
        path: "new",
        name: "pupil_feedback-public_responses-new",
        component: () => import("./assignments/[id].public_responses/new.vue"),
        meta: {
          namespace: "pupil_feedback",
          title: "tools_meta.pupil_feedback_prefix",
        },
      },
      {
        path: ":responseId",
        name: "pupil_feedback-public_responses-show",
        component: () =>
          import("./assignments/[id].public_responses/PublicResponseDetailPage.vue"),
        meta: {
          namespace: "pupil_feedback",
          title: "tools_meta.pupil_feedback_prefix",
        },
      },
    ],
  },
  {
    path: "/pupil_feedback/assignments/:id/responses",
    name: "pupil_feedback-responses-index",
    component: () =>
      import("./assignments/[id].responses/ResponseListPage.vue"),
    meta: {
      requiresAuth: true,
      title: "tools_meta.pupil_feedback_prefix",
    },
  },
  // This route has nested children via RouterView
  {
    path: "/pupil_feedback/assignments/:id/responses/:responsePage",
    name: "pupil_feedback-responses-show",
    component: () =>
      import("./assignments/[id].responses/ResponsePageDetailPage.vue"),
    meta: {
      requiresAuth: true,
      title: "tools_meta.pupil_feedback_prefix",
    },
    children: [
      {
        path: "feedback/:feedbackType",
        name: "pupil_feedback-responses-show-feedback_type",
        component: () =>
          import("./assignments/[id].responses/[responsePage]/feedback.[feedbackType].vue"),
        meta: {
          requiresAuth: true,
          title: "tools_meta.pupil_feedback_prefix",
        },
      },
    ],
  },
];
